// Fil: src/KontaktpersonerListe.js (Opdateret med Sprogcenter-først flow)

import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

// DEFINER DE FASTE ROLLER HER
const ROLLE_OPTIONS = [
  'Forstander',
  'Prøveansvarlig',
  'Souschef',
  'Modultestansvarlig',
  'Kommunal kontaktoplysning',
  'Administrativ medarbejder'
];

const initialFormState = {
    sprogcenter_id: '',
    rolle: '',
    navn: '',
    telefon: '',
    email: '',
};

function KontaktpersonerListe() {
  const [kontaktpersoner, setKontaktpersoner] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formState, setFormState] = useState(initialFormState);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [sprogcentre, setSprogcentre] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(true);


  const [valgtSprogcenter, setValgtSprogcenter] = useState(null); // null = vis sprogcenter-liste

  const API_BASE_URL_KONTAKTPERSONER = `${process.env.REACT_APP_API_URL}/api/kontaktpersoner`;
  const API_BASE_URL_SPROGCENTRE = `${process.env.REACT_APP_API_URL}/api/sprogcentre`;


  useEffect(() => {
    const fetchData = async () => {
        setLoading(true); setLoadingOptions(true); setError(null);
        try {
            const fetchOptions = { credentials: 'include' };
            const [kontaktRes, sprogcenterRes] = await Promise.all([
                fetch(API_BASE_URL_KONTAKTPERSONER, fetchOptions),
                fetch(API_BASE_URL_SPROGCENTRE, fetchOptions)
            ]);
            if (!kontaktRes.ok) throw new Error(`Kontaktpersoner: ${kontaktRes.statusText || kontaktRes.status}`);
            if (!sprogcenterRes.ok) throw new Error(`Sprogcentre: ${sprogcenterRes.statusText || sprogcenterRes.status}`);
            
            const kontaktData = await kontaktRes.json();
            const sprogcenterData = await sprogcenterRes.json();

            setKontaktpersoner(kontaktData);
            setSprogcentre(sprogcenterData); // Gemmer alle sprogcentre
        } catch (err) {
            console.error("Fejl ved hentning af data:", err); setError(err.message);
        } finally {
            setLoading(false); setLoadingOptions(false);
        }
    };
    fetchData();
  }, []);
  
  // Funktion til at gen-hente KUN kontaktpersoner (nyttigt efter submit/delete)
  const fetchKontaktpersoner = async () => {
      setLoading(true);
      try {
          const response = await fetch(API_BASE_URL_KONTAKTPERSONER, { credentials: 'include' });
          if(!response.ok) throw new Error(`Kontaktpersoner: ${response.statusText || response.status}`);
          const data = await response.json();
          setKontaktpersoner(data);
      } catch (err) {
          setError(err.message)
      } finally {
          setLoading(false);
      }
  }


  const openModal = (kontaktperson = null) => {
    setModalError(null);
    if (kontaktperson) {
      setEditingId(kontaktperson.id);
      setFormState({
        sprogcenter_id: kontaktperson.sprogcenter_id || '',
        rolle: kontaktperson.rolle || '',
        navn: kontaktperson.navn || '',
        telefon: kontaktperson.telefon || '',
        email: kontaktperson.email || '',
      });
    } else {
      setEditingId(null);
      // Pre-fill sprogcenter hvis et er valgt
      setFormState({ ...initialFormState, sprogcenter_id: valgtSprogcenter ? valgtSprogcenter.id : '' });
    }
    setModalIsOpen(true);
  };
  const closeModal = () => { setModalIsOpen(false); setEditingId(null); };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setModalError(null);
    if (!formState.sprogcenter_id || !formState.rolle.trim()) {
      setModalError('Sprogcenter og Rolle er påkrævede felter.');
      return;
    }

    const method = editingId ? 'PUT' : 'POST';
    const url = editingId ? `${API_BASE_URL_KONTAKTPERSONER}/${editingId}` : API_BASE_URL_KONTAKTPERSONER;

    try {
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
        credentials: 'include'
      });
      if (!response.ok) { const errorText = await response.text(); throw new Error(errorText || `Serverfejl: ${response.status}`); }
      
      closeModal();
      await fetchKontaktpersoner(); // Gen-hent kun kontaktpersoner
    } catch (err) {
      console.error("Fejl ved submit:", err);
      setModalError(`Kunne ikke gemme: ${err.message}`);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(`Sikker på du vil slette kontaktperson med ID ${id}?`)) return;
    try {
      const response = await fetch(`${API_BASE_URL_KONTAKTPERSONER}/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (!response.ok && response.status !== 204) { const errorText = await response.text(); throw new Error(errorText || `Serverfejl: ${response.status}`); }
      
      await fetchKontaktpersoner(); // Gen-hent kun kontaktpersoner
    } catch (err) {
      console.error("Fejl ved sletning:", err);
      setError(`Kunne ikke slette: ${err.message}`);
    }
  };
  
  // Filtrer kontaktpersoner baseret på det valgte sprogcenter
  const filtreredeKontaktpersoner = valgtSprogcenter
    ? kontaktpersoner.filter(kp => kp.sprogcenter_id === valgtSprogcenter.id)
    : [];

  return (
    <div>
      <h2 className="page-main-header">
        {valgtSprogcenter ? `Kontaktpersoner for ${valgtSprogcenter.navn}` : 'Vælg et Sprogcenter'}
      </h2>
      {error && !modalIsOpen && <p className="error-message">{error}</p>}
      
      {/* Vis enten sprogcenter-listen ELLER kontaktperson-listen */}
      {!valgtSprogcenter ? (
        // *** 1. VISNING: LISTE AF SPROGCENTRE ***
        <div className="table-container" style={{marginTop: '20px'}}>
          {loading ? (<p className="info-message">Henter data...</p>) : 
           sprogcentre.length === 0 && !error ? (<p className="info-message">Ingen sprogcentre fundet.</p>) : 
           (
            <table className="censor-table termin-clickable-table">
              <thead><tr><th>Sprogcenter Navn</th><th style={{width: '120px', textAlign: 'center'}}>Handlinger</th></tr></thead>
              <tbody>
                {sprogcentre.map(sc => (
                  <tr key={sc.id} onClick={() => setValgtSprogcenter(sc)} title={`Vis kontaktpersoner for ${sc.navn}`}>
                    <td><strong>{sc.navn}</strong></td>
                    <td style={{textAlign: 'center'}}><button className="view-button small-button" onClick={(e) => { e.stopPropagation(); setValgtSprogcenter(sc); }}>Vis Kontakter</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        // *** 2. VISNING: LISTE AF KONTAKTPERSONER FOR VALGT SPROGCENTER ***
        <div>
          <button onClick={() => setValgtSprogcenter(null)} className="back-button" style={{marginBottom: '15px'}}>← Tilbage til Sprogcentre</button>
          <div className="add-new-button-container" style={{display: 'inline-block', marginLeft: '20px'}}>
            <button onClick={() => openModal()} className="toggle-form-button primary-action" disabled={loadingOptions}>
                Tilføj Kontaktperson til {valgtSprogcenter.navn}
            </button>
          </div>

          {loading && <p className="info-message">Henter data...</p>}
          {!loading && filtreredeKontaktpersoner.length === 0 && !error && (<p className="info-message">Ingen kontaktpersoner fundet for dette sprogcenter.</p>)}
          {!loading && filtreredeKontaktpersoner.length > 0 && (
            <div className="table-container">
              <table className="censor-table">
                <thead>
                  <tr><th>Rolle</th><th>Navn</th><th>Telefon</th><th>Email</th><th className="action-cell">Handlinger</th></tr>
                </thead>
                <tbody>
                  {filtreredeKontaktpersoner.map(kp => (
                    <tr key={kp.id}>
                      <td><strong>{kp.rolle}</strong></td>
                      <td>{kp.navn || '-'}</td>
                      <td>{kp.telefon}</td>
                      <td>{kp.email}</td>
                      <td className="action-cell">
                        <button onClick={() => openModal(kp)} className="edit-button icon-button" title="Rediger"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" /><path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" /></svg></button>
                        <button onClick={() => handleDelete(kp.id)} className="delete-button icon-button" title="Slet"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px" className="delete-icon"><path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.9h1.368c1.603 0 2.816 1.336 2.816 2.9zm-1.452.721a.75.75 0 01.216-.534l.018-.018a.75.75 0 01.706-.216L17.5 5.25a.75.75 0 01.216.534l-.018.018a.75.75 0 01-.706.216l-1.281-.214a.75.75 0 01-.216-.534z" clipRule="evenodd" /></svg></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Kontaktperson Form" className="ReactModal__Content" overlayClassName="ReactModal__Overlay">
        <form onSubmit={handleSubmit} className="modal-form">
          <h3>{editingId ? `Rediger Kontaktperson (ID: ${editingId})` : 'Tilføj Ny Kontaktperson'}</h3>
          {modalError && <p className="error-message">{modalError}</p>}
          
          <div className="form-field">
            <label htmlFor="sprogcenter_id">Tilhører Sprogcenter:*</label>
            <select id="sprogcenter_id" name="sprogcenter_id" value={formState.sprogcenter_id} onChange={handleInputChange} required disabled={loadingOptions}>
              <option value="">-- Vælg Sprogcenter --</option>
              {sprogcentre.map(sc => <option key={sc.id} value={sc.id}>{sc.navn}</option>)}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="rolle">Rolle:*</label>
            <select 
              id="rolle" 
              name="rolle" 
              value={formState.rolle} 
              onChange={handleInputChange} 
              required
            >
              <option value="">-- Vælg Rolle --</option>
              {ROLLE_OPTIONS.map(rolle => (
                <option key={rolle} value={rolle}>{rolle}</option>
              ))}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="navn">Navn:</label>
            <input type="text" id="navn" name="navn" value={formState.navn} onChange={handleInputChange} />
          </div>
          <div className="form-row">
            <div className="form-field"><label htmlFor="telefon">Telefon:</label><input type="tel" id="telefon" name="telefon" value={formState.telefon} onChange={handleInputChange} /></div>
            <div className="form-field"><label htmlFor="email">Email:</label><input type="email" id="email" name="email" value={formState.email} onChange={handleInputChange} /></div>
          </div>
          <div className="modal-actions">
            <button type="submit">{editingId ? 'Gem Ændringer' : 'Opret Kontaktperson'}</button>
            <button type="button" onClick={closeModal} className="cancel-button">Annuller</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default KontaktpersonerListe;